<template>
    <div class="daily-rancing daily">
        <div class="daily-rancing__table scrollbar">
            <div class="daily-rancing__header">
                <div>NGƯỜI CHƠI</div>
                <div>THỜI GIAN</div>
                <div>GIẢI THƯỞNG</div>
            </div>
            <div class="daily-rancing__content">
                <ul v-if="listWinner && listWinner.length > 0" class="content">
                    <li v-for="(item, index) in listWinner" :key="index">
                        <div class="user">
                            <img class="avatar" :src="`${$store.state.mapDomain.STATIC_URL}/assets/img/event/worldcup/section-slots/avatar.png`" alt="avatar">
                            <span class="name">{{item.username}}</span>
                        </div>
                        <div class="time"><span>{{item.datetime | formatDate('HH:mm | DD-MM-YYYY')}}</span></div>
                        <div><span class="number">{{checkStatus(item.result)}}</span></div>
                    </li>
                </ul>
                <div v-else class="not-data text-center">
                    <img class="icon" :src="`${$store.state.mapDomain.STATIC_URL}/assets/img/event/worldcup/icon-empty.svg`" alt="empty">
                    <div class="top">TOP TRỐNG</div>
                    <div class="sub">Hệ thống sẽ cập nhật thông tin sớm nhất!</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
    data() {
        return {
            isLoading: false,
            isSubmit: false
        };
    },
    computed: {
        ...mapState('event/worldcup-wheel', {
            listWinner: state => state.summaryWinner.listWinner
        })
    },
    methods: {
        async getDailyWinner() {
            try {
                if (this.isLoading) {
                    return;
                }
                this.isLoading = true;
                await this.$store.dispatch('event/worldcup-wheel/getDailyWinner');
                this.isLoading = false;
                this.isSubmit = false;
            } catch (error) {
                console.log(error);
                this.isSubmit = false;
                this.isLoading = false;
                this.$alertError('Server lỗi ! Vui lòng thử lại sau!');
            }
        },
        checkStatus(item) {
            let $text = '';
            switch (item) {
                case 'match_win':
                    $text = '1 Trận thắng';
                    break;
                case 'match_lose':
                    $text = '1 Trận thua';
                    break;
                case 'match_draw':
                    $text = '1 Trận hòa';
                    break;
                case 'money_fifty':
                    $text = '50,000 VND';
                    break;
                case 'money_two_thousand':
                    $text = '2,000,000 VND';
                    break;
                case 'money_one_thousand':
                    $text = '1,000,000 VND';
                    break;
                case 'money_five_hundred':
                    $text = '500,000 VND';
                    break;
                case 'money_three_hundred':
                    $text = '300,000 VND';
                    break;
                case 'money_one_hundred':
                    $text = '100,000 VND';
                    break;
                case 'money_ten':
                    $text = '10,000 VND';
                    break;
                case 'super_return':
                    $text = 'Siêu hoàn trả';
                    break;
                default:
                    $text = 'Lucky';
                    break;
            }
            return $text;
        }
    },
    mounted() {
        this.$nextTick(async () => {
            await this.getDailyWinner();
        });
    }
};
</script>
